<template>
  <div class="bg-white rounded-lg p-2">
    <div class="flex justify-center">
      <LoadingSpinner
        class="h-10 w-10 text-yellow-500/80 my-8"
        v-if="loading"
      />
      <apexchart
        class=""
        type="bar"
        width="350"
        :options="options"
        :series="series"
        v-else-if="this.series.length"
      />
      <h6 class="my-8 text-gray-600" v-else>بدون داده</h6>
    </div>
  </div>
</template>
<script>
import { saleCountReport } from "../API/API";
import LoadingSpinner from "../components/General/LoadingSpinner.vue";
export default {
  name: "SaleProductChart",
  components: { LoadingSpinner },
  props: ["year", "month", "day"],
  data() {
    return {
      loading: true,
      series: [],
      options: {
        fontFamily: "iransans",
        labels: [],
        colors: ["#701A75", "#831843", "#14532D"],
        // dataLabels: {
        //   style: {
        //     colors: ["#e5e5e5"],
        //   },
        // },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["1402"],
        },
      },
    };
  },
  created() {
    this.getReports();
  },
  methods: {
    getReports() {
      this.series = [];
      this.options.labels = [];
      this.loading = true;
      saleCountReport("year", "qty", this.year, this.month, this.day).then(
        (resp) => {
          resp.data.result.yaxis.forEach((item) => {
            if (item.dData.length) {
              this.series.push({
                name: item.name,
                data: [item.dData[0]],
              });
            }
          });

          this.loading = false;
        }
      );
    },
  },
  watch: {
    day() {
      if (this.day !== "") this.getReports();
    },
    month() {
      this.getReports();
    },
    year() {
      this.getReports();
    },
  },
};
</script>
